const actionTypeIdentifier = "692A4A8E-6DC3-4990-9137-CD6E84C7BA28";

export const getReleaseNotesItems = `GET-RELEASE-NOTES-ITEMS-${actionTypeIdentifier}`;
export const checkNewReleaseNotes = `CHECK-NEW-RELEASE-NOTES-${actionTypeIdentifier}`;
export const setIsFetching = `SET-IS-FETCHING-${actionTypeIdentifier}`;
export const confirmedReleaseNotesNotification = `CONFIRMED_RELEASE_NOTES_NOTIFICATION-${actionTypeIdentifier}`;